<template>
  <div style="min-height: 768px" class="">
    <div class="text-center back">
      <div class="title1 text-center pt-5 pb-2 px-5">
        Cursos para profesionales de la salud
      </div>
    </div>
    <div class="box mx-auto pb-5">
      <div
        class="row col-12 title2 mt-3 justify-content-center text-center pt-4 px-5 mx-0"
      >
        Aprender te mantiene a la vanguardia. <br>Consigue las habilidades más demandadas y enciende tus ganas de aprender!.
      </div>

      <div class="contain-slide">
        <VueSlickCarousel v-if="getLength" v-bind="settings" class="d-md-none ">
          <cat-item
            v-for="(category, i) in categories_data"
            v-bind:key="i"
            :itemData="category"
            
            style="height: 289px;"
          ></cat-item>
        </VueSlickCarousel>
      </div>

      <div class="hidden md:flex md:flex-wrap md:justify-center">
        <cat-item style="border-radius: 25px"
          v-for="(category, i) in categories_data"
          v-bind:key="i"
          :itemData="category"
        ></cat-item>
      </div>

      <div class="row col-12 mt-5 px-0 mx-0">
        <img src="/image/resource/filete.svg" class="w-100" />
      </div>

      <div class="row col-12 mt-5 mx-0">
        <button
          class="btn orange-btn mx-auto orangeH"
          @click="showModal = true"
        >
          Contactanos
        </button>
      </div>
      <contact
        @close="closeModal()"
        v-if="showModal"
        :show="showModal"
      ></contact>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import CatItem from "../../components/CatItem.vue";
import Contact from "../../components/Contact.vue";
import VueSlickCarousel from "vue-slick-carousel";

export default {
  name: "getCategories",
  components: {
    CatItem,
    Contact,
    VueSlickCarousel
  },
  created() {
    this.getCategories();
  },
  data() {
    return {
      showModal: false,
      currentSlide: 0,
      settings: {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
      },
      myOptions: {
        navButtons: false,
        dots: false,
        infinite: false
      },

    
      proyect_id: process.env.VUE_APP_PROYECT_ID,
      spiner: false,
      color: "#9A32D6"
    };
  },
  computed: {
    ...mapState,
    ...mapGetters({ categories: "category/allCategories" }),
    getLength() {
      return this.categories.length;
    },
    categories_data: function() {
      if (this.categories) {
        return this.categories.slice(0, 8);
      } else {
        return this.categories;
      }
    }
  },
  methods: {
    getCategories: function() {
      this.spiner = true;
      this.$store
        .dispatch("category/getCategory")
        .then(() => {
          this.spiner = false;
        })
        .catch(error => {
          console.log(error);
        });
    },

    closeModal() {
      this.showModal = false;
    },
    coursesCategories: function(id, name) {
      var slug = "";
      // Change to lower case
      var titleLower = name.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      /* localStorage.setItem('e_x_c', (JSON.stringify(courses.courses)));*/
      this.$router.push("/courses/category/" + id + "/" + slug);
    }
  }
};
</script>

<style scoped>

.contain-slide {
  width: 80%;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 50px;
}

::v-deep .agile__caption {
  width: fit-content;
  margin: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: #848484;
  font-size: 18px;
}

i {
  font-size: 24px;
}

::v-deep button:not(:disabled) {
  cursor: pointer;
  margin: 0 5px;
  color: black;
}

::v-deep .agile__actions {
  justify-content: center;
}

.title2 {
  font-family: "Roboto Condensed", sans-serif;
  font-size: 20px;
  font-weight: bold;
  padding-top: 30px !important;
  color: #0f1424;
}

.box {
  background: transparent linear-gradient(180deg, #cbcbcb73 1%, #fdf5f970 100%)
    0% 0% no-repeat padding-box;
}

@media (max-width: 540px) {
  .title2 {
    font-size: 15px !important;
  }

  .title1 {
    font-size: 25px !important;
    line-height: 28px !important;
  }
}

@media (max-width: 1240px) {
  .title2 {
    /* height: 180px;
    background: #ecebeb; */
    /* border-bottom-right-radius: 200% 400px;
    border-bottom-left-radius: 200% 400px; */
  }
}

.title1 {
  line-height: normal;
  font-family: "Roboto-Bold", sans-serif;
  color: #446daf;
  font-weight: bold;
  line-height: 48px;
  font-size: 47.32px;
  text-align: left;
}

.mt-50 {
  margin-top: 50px;
}

.orange-btn {
  background: transparent linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  color: white !important;
  width: 284px;
  height: 52px;
}

.backgray {
  background: #d2d1d2;
}

@media (min-width: 1200px) {
  .content-courses {
    margin-left: auto;
    margin-right: auto;
    max-width: 1200px;
    display: flex;
  align-items: center;
  justify-content: center;
  }
}
</style>
